import  { useEffect, useState } from 'react';
import { SCREEN_SIZE } from '../utils/constant/constant';

type widnowSize = {
    height: number,
    width: number
}

const useWindowResize = () => {
    const [size, setSize] = useState<widnowSize>({
        height: window.innerHeight,
        width: window.innerWidth
    });

    const [screenDevice, setScreenDevice] = useState<string>(SCREEN_SIZE.EXTRA_LARGE_SCREEN);
    

    useEffect(()=>{
        const resizeHandler = ()=>{
            setSize({
                height: window.innerHeight,
                width: window.innerWidth
            });
            screenSizeHandler(window.innerWidth);
        }
        const screenSizeHandler = (width: number) => {
            if(width<=480){
                    setScreenDevice(SCREEN_SIZE.EXTRA_SMALL_SCREEN);
            }else if(width<=768){
                setScreenDevice(SCREEN_SIZE.SMALL_SCREEN);
            }else if(width<=992){
                setScreenDevice(SCREEN_SIZE.MEDIUM_SCREEN);
            }else if(width<=1280){
                setScreenDevice(SCREEN_SIZE.LARGE_SCREEN);
            }else{
                setScreenDevice(SCREEN_SIZE.EXTRA_LARGE_SCREEN);
            }
        }
        screenSizeHandler(window.innerWidth);
        window.addEventListener('resize',resizeHandler);
        return ()=>{
            window.removeEventListener('resize',resizeHandler);
        }
    }, []);
    return { screenDevice, size };
}

export default useWindowResize;
